import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import ForWhom from './components/ForWhom';
import Process from './components/Process';
import CTA from './components/CTA';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <ForWhom />
        <Process />
        <CTA />
      </main>
    </div>
  );
}

export default App;
